import React, { useState, useEffect, useRef } from "react";
import "./AwardsTab.css";
import data2025 from "../../data/AwardsData/awards2025.json";
import data2024 from "../../data/AwardsData/awards2024.json";
import data2023 from "../../data/AwardsData/awards2023.json";
import data2022 from "../../data/AwardsData/awards2022.json";
import data2021 from "../../data/AwardsData/awards2021.json";
import data2020 from "../../data/AwardsData/awards2020.json";
import data2019 from "../../data/AwardsData/awards2019.json";
import data2018 from "../../data/AwardsData/awards2018.json";
import data2017 from "../../data/AwardsData/awards2017.json";
import awardImagesByYear from "./AwardImagesByYear";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

// Mapping year to data
const dataMap = {
  2025: data2025,
  2024: data2024,
  2023: data2023,
  2022: data2022,
  2021: data2021,
  2020: data2020,
  2019: data2019,
  2018: data2018,
  2017: data2017,
};

const allCategories = [
  "gold",
  "silver",
  "bronze",
  "hrd",
  "accenture",
  "atd",
  "tiss",
];

const AwardsTab = () => {
  const years = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017];
  const [selectedYear, setSelectedYear] = useState(2025);
  const [awards, setAwards] = useState([]);

  const tabRefs = useRef({});
  const accordionRefs = useRef({});

  useEffect(() => {
    accordionRefs.current[selectedYear] = [];
    setAwards(dataMap[selectedYear]);
  }, [selectedYear]);

  const getAwardsByCategory = (category) =>
    awards.filter((item) => item.category.toLowerCase() === category);

  const categoriesWithData = allCategories.filter(
    (cat) => getAwardsByCategory(cat).length > 0
  );

  const totalAwards = awards.length;

  const handleTabKeyOnYear = (e, year) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const refs = accordionRefs.current[year];
      if (!refs || refs.length === 0) return;

      const nonNullRefs = refs
        .filter((el) => el !== null)
        .sort((a, b) => {
          const rectA = a.getBoundingClientRect();
          const rectB = b.getBoundingClientRect();
          if (rectA.top === rectB.top) return rectA.left - rectB.left;
          return rectA.top - rectB.top;
        });

      const firstAccordion = nonNullRefs[0];
      firstAccordion?.focus();
    }
  };

  return (
    <div className="award-main-container">
      <div className="tab-container">
        {/* Year Tabs */}
        <div className="tabs">
          {years.map((year) => (
            <button
              key={year}
              ref={(el) => (tabRefs.current[year] = el)}
              className={`tab-button ${selectedYear === year ? "active" : ""}`}
              onClick={() => setSelectedYear(year)}
              onKeyDown={(e) => handleTabKeyOnYear(e, year)}
              tabIndex={selectedYear === year ? 0 : -1}
            >
              {year}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="content">
          <h2 className="main-headings">
            {totalAwards} Learning Awards - FY{String(selectedYear).slice(-2)}
          </h2>

          <div className="award-columns">
            {categoriesWithData.map((cat) => (
              <div className="column" key={cat}>
                <h3 className={cat}>
                  <span>
                    {getAwardsByCategory(cat).length} {cat}{" "}
                  </span>
                  {getAwardsByCategory(cat)[0]?.award_cup_text} Awards
                </h3>

                <div className="award-images">
                  {awardImagesByYear[selectedYear] &&
                    awardImagesByYear[selectedYear]
                      .filter((img) =>
                        img.toLowerCase().includes(cat.toLowerCase())
                      )
                      .map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`${cat} award`}
                          className="award-image"
                          onError={() =>
                            console.error(`Failed to load image: ${img}`)
                          }
                        />
                      ))}
                </div>

                {/* Accordion */}
                <Accordion
                  items={getAwardsByCategory(cat)}
                  category={cat}
                  year={selectedYear}
                  accordionRefs={accordionRefs}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// Accordion Component
const Accordion = ({ items, category, year, accordionRefs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="accordion">
      {items.map((item, idx) => {
        const isActive = activeIndex === idx;
        return (
          <div key={idx} className="accordion-item">
            <div
              className="accordion-title"
              onClick={() => toggleIndex(idx)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") toggleIndex(idx);
              }}
              tabIndex={0}
              ref={(el) => {
                if (!accordionRefs.current[year]) {
                  accordionRefs.current[year] = [];
                }
                accordionRefs.current[year].push(el);
              }}
            >
              <span>{item["award_head"]}</span>
              <span className="arrow">
                {isActive ? <FiChevronUp /> : <FiChevronDown />}
              </span>
            </div>
            {isActive && (
              <>
                <div className="accordion-subhead">{item["award_subhead"]}</div>
                <div className="accordion-text">{item["award_text"]}</div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AwardsTab;
